<template>
    <div v-if="showModal" class="modal">
        <div class="inner">
            <h2>Compare Report Dates</h2>
            <div class="content compare-columns">
                <div>
                    <h3 class="column-heading">Year</h3>
                    <div v-for="(year, index) in yearList">
        				<label class="radio">
        					<input type="radio" v-model="reportYear" :value="year" @change="setDates()">
        					<span :class="section"><i class="fas fa-check-circle"></i>{{ year }}</span>
        				</label>
                    </div>
                </div>
                <div>
                    <h3 class="column-heading">Month</h3>
                    <div class="month-columns">
        				<label v-for="(month, index) in monthList" class="radio">
        					<input type="radio" v-model="reportMonth" :value="index" @change="setDates()">
        					<span :class="section"><i class="fas fa-check-circle"></i>{{ month }}</span>
        				</label>
                    </div>
                </div>
                <div>
                    <h3 class="column-heading">Custom</h3>
                    <label>Start</label>
                    <input :class="section" type="date" v-model="startDate">
                    <label>End</label>
                    <input :class="section" type="date" v-model="endDate">
                </div>

            </div>
            <div class="modal-controls">
                <div class="button cancel" @click="cancelModal()">Cancel</div>
                <div :class="['button', section]" @click="loadReport()">Load Report</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'compare-dates',
    props: ['active', 'section'],
    data () {
        return {
            reportYear: new Date().getFullYear(),
            reportMonth: new Date().getMonth(),
            startYear: '2020',
            startDate: '',
            endDate: '',
            showModal: false
        }
    },
    created() {
        this.setDates()
        this.showModal = this.active ? true : false
	},
	watch: {
		active: function() {
            this.showModal = this.active ? true : false
        }
	},
	computed: {
        yearList() {
            let years = []
            for (let i = this.startYear; i <= new Date().getFullYear(); i++) {
                years.push(i)
            }
            return years
        },
		monthList() {
			return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
		}
	},
	methods: {
        cancelModal() {
            this.$emit('cancel')
        },
        setDates() {
            let startDateParameter = this.reportYear + '-' + ((this.reportMonth+1).toString().padStart(2, '0')) + '-01'
            let lastDayOfMonth = new Date(this.reportYear, this.reportMonth+1, 0).getDate();
            let endDateParameter = this.reportYear + '-' + ((this.reportMonth+1).toString().padStart(2, '0')) + '-' + lastDayOfMonth
            this.startDate = startDateParameter
            this.endDate = endDateParameter
        },
        loadReport() {
            let urlParts = window.location.href.split('?')
            let url = urlParts[0] + '?start=' + this.startDate + '&end=' + this.endDate
            window.open(url, '_blank')
            // nothing changes in parent view, so no need to emit anything!
            this.cancelModal()
        }
	}
}
</script>
<style lang="scss" scoped>
.modal {
    .inner {
		max-width: 60em;
	}
}
.column-heading {
    color: #666;
    border-bottom: 1px solid #666;
}
.compare-columns {
    display: grid;
    grid-template-columns: 6em 1fr 10em;
    grid-column-gap: 3em;
}
.month-columns {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    label.radio span {
        width: 7em;
    }
}
</style>
